<!-- The Modal-->
<div class="modal" id="renameAnswerTemplateModal" *ngIf="answerTemplate">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-lock"></span>
          Editing {{answerTemplate.name}}
          </h4>
          <button type="button" class="btn btn-danger" (click)="closeAnswerTemplateRenameModal()">&times;</button>

      </div>

      <!-- Modal body -->
      <div class="modal-body">
        <form [formGroup] = "myForm" (ngSubmit)="on_submit()" class="form" enctype="multipart/form-data">
          <div class="form-group row" [ngClass]="{error:f.answerTemplateName.errors && f.answerTemplateName.touched}">
            <label for="subjectId" class='control-label col-sm-3' >Template Name</label>
                <div class="input-group controls col-sm-8">
                  <input type="text"
                      id="answerTemplateName"
                      formControlName="answerTemplateName">
                </div>
                <div *ngIf="f.answerTemplateName.errors && f.answerTemplateName.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
                  <ul>
                      <li>taskTemplate Name Required.</li>
                  </ul>
              </div>
          </div>


  <fieldset class="buttons text-center">
  <button type="submit" class="btn btn-primary margin-50-right">Submit</button>
  <button type="button" class="btn btn-danger" (click)="closeAnswerTemplateRenameModal()">Close</button>
  </fieldset>
  </form>
</div>
</div>
</div>
</div>
